import { render, staticRenderFns } from "./QuotesForm.vue?vue&type=template&id=00df82d0"
import script from "./QuotesForm.vue?vue&type=script&lang=js"
export * from "./QuotesForm.vue?vue&type=script&lang=js"
import style0 from "./QuotesForm.vue?vue&type=style&index=0&id=00df82d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports